import type { Common } from "@beautypie/segment";
import parser from "ua-parser-js";

import { isBrowser } from "@shared/utils.environment";

import type { DeepRequired } from "tracking";

type OS = DeepRequired<Common, ["context", "os"]>["context"]["os"];

export const parseOS = (): OS | undefined => {
  if (isBrowser()) {
    const {
      os: { name, version }
    } = parser(navigator.userAgent);
    return {
      name,
      version
    };
  }

  return undefined;
};
